import React from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import SafeIcon from '../common/SafeIcon';
import * as FiIcons from 'react-icons/fi';

const { FiCheck } = FiIcons;

const SyncTick = () => {
  return (
    <AnimatePresence>
      <motion.div
        initial={{ opacity: 0, y: 20, x: -20 }}
        animate={{ opacity: 1, y: 0, x: 0 }}
        exit={{ opacity: 0, y: 20, x: -20 }}
        transition={{ duration: 0.3 }}
        className="fixed bottom-6 left-6 z-50"
      >
        <div className="bg-green-500/10 backdrop-blur-sm border border-green-400/20 text-green-200 px-2.5 py-1 rounded-full shadow-sm flex items-center gap-1.5">
          <SafeIcon icon={FiCheck} className="w-3 h-3" />
          <span className="text-xs font-semibold">Updated</span>
        </div>
      </motion.div>
    </AnimatePresence>
  );
};

export default SyncTick;